export default function getDefaultStoreKey(appKey, namespace) {
	return 'apps.' + appKey + '.' + namespace;
}



// WEBPACK FOOTER //
// ./src/core/utils/getDefaultStoreKey.js